import {makeObservable, observable} from "mobx";
import {BaseModel} from "../../../infrastructure/models/base-model";

export class PropositionBetsDetailsDisplayModel extends BaseModel {
  @observable athleteId: Number;
  @observable lineTypeId: Number;
  @observable gameId: Number;

  constructor() {
    super();

    this.athleteId = null;
    this.lineTypeId = null;
    this.gameId = null;

    makeObservable(this);
  }

  clear() {
    this.athleteId = null;
    this.lineTypeId = null;
    this.gameId = null;
  }
}
